export default __webpack_public_path__ + "static/media/account_icon.b9cd6e86.svg";